import { toast } from 'react-toastify';
import { ENVIOS_API } from '../views/MainLayout/components/shared/services/envios';

const initialDashboard = {
    dashboardTab: null,
    enviosTab: null,
    alertasTab: null,
    shippingResults: null,
    isLoading: false,
};

const updateShippingStates = (
    shipping_states,
    estadoId,
    isNacional,
    newState
) =>
    shipping_states.map((state) => {
        if (state.estado_id === estadoId) {
            return {
                ...state,
                [isNacional ? 'count_nacional' : 'count_internacional']:
                    state[
                        isNacional ? 'count_nacional' : 'count_internacional'
                    ] - 1,
            };
        }

        if (state.nombre === newState || state.estado_id === newState) {
            return {
                ...state,
                [isNacional ? 'count_nacional' : 'count_internacional']:
                    state[
                        isNacional ? 'count_nacional' : 'count_internacional'
                    ] + 1,
            };
        }

        return state;
    });

export const enviosReducer = (state = initialDashboard, action) => {
    switch (action.type) {
        case 'envios/fullfilled': {
            return {
                ...state,
                enviosTab: action.payload,
            };
        }
        case 'envios-metrics/fullfilled': {
            return {
                ...state,
                dashboardTab: action.payload,
            };
        }
        case 'envios-metrics/add-new-shipment': {
            return {
                ...state,
                dashboardTab: {
                    ...state.dashboardTab,
                    shipping_states: updateShippingStates(
                        state.dashboardTab.shipping_states,
                        null,
                        action.payload.isNacional,
                        action.payload.newState
                    ),
                },
            }
        }
        case 'envios-alertas/fullfilled': {
            return {
                ...state,
                alertasTab: action.payload
            }
        }
        case 'envios-alertas/reset': {
            return {
                ...state,
                alertasTab: null
            }
        }
        case 'shipping-results/fullfilled': {
            return {
                ...state,
                shippingResults: action.payload,
            };
        }
        case 'shipping-results/reset': {
            return {
                ...state,
                shippingResults: null,
            };
        }
        case 'shipping-results/update': {
            return {
                ...state,
                shippingResults: {
                    ...state.shippingResults,
                    envios: state.shippingResults?.envios?.map((shipment) =>
                        shipment.id === action.payload.id
                            ? { ...shipment, ...action.payload }
                            : shipment
                    ),
                },
            };
        }
        case 'shipping-results/change-state': {
            return {
                ...state,
                shippingResults: {
                    total_items: state.shippingResults?.total_items - 1,
                    envios: state.shippingResults?.envios?.filter(
                        (shipment) => shipment.id !== action.payload.shipmentId
                    ),
                },
                dashboardTab: {
                    ...state.dashboardTab,
                    shipping_states: updateShippingStates(
                        state.dashboardTab.shipping_states,
                        action.payload.estadoId,
                        action.payload.isNacional,
                        action.payload.newState
                    ),
                },
            };
        }
        case 'envios/loading': {
            return {
                ...state,
                isLoading: action.payload,
            };
        }
        default:
            return state;
    }
};

export const fetchEnvios = (page, search) => async (dispatch) => {
    dispatch({ type: 'loading/set', payload: true });
    try {
        const response = await ENVIOS_API.get(page, search);
        const data = await response.data;
        dispatch({ type: 'envios/fullfilled', payload: data });
    } catch (e) {
        toast.error(e.message);
    } finally {
        dispatch({ type: 'loading/set', payload: false });
    }
};

export const fetchEnviosMetrics =
    (startDate, endDate, clean_cache = false) =>
    async (dispatch) => {
        try {
            dispatch({ type: 'envios/loading', payload: true });
            const response = await ENVIOS_API.getDashboard(
                startDate,
                endDate,
                clean_cache
            );
            const data = await response.data;
            dispatch({ type: 'envios-metrics/fullfilled', payload: data });
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'envios/loading', payload: false });
        }
    };

export const updateEnviosMetrics = (isNacional, newState) => (dispatch)  => {
    dispatch({type: 'envios-metrics/add-new-shipment', payload: { isNacional, newState }})
}

export const fetchAlertasEnvios =
    (page, transportista, isFirstOpen = false) =>
    async (dispatch) => {
        dispatch({
            type: isFirstOpen ? 'envios/loading' : 'loading/set',
            payload: true,
        });
        try {
            const response = await ENVIOS_API.getAlerts(page, transportista);
            const data = await response.data;
            dispatch({ type: 'envios-alertas/fullfilled', payload: data });
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({
                type: isFirstOpen ? 'envios/loading' : 'loading/set',
                payload: false,
            });
        }
    };

export const resetAlertasEnvios = () => (dispatch) => {
    dispatch({ type: 'envios-alertas/reset' });
}

export const fetchEnviosByState =
    (estadoId, isNacional, page, search) => async (dispatch) => {
        try {
            dispatch({ type: 'loading/set', payload: true });
            const response = await ENVIOS_API.getByStatusId(
                estadoId,
                isNacional,
                page,
                search
            );
            const data = await response.data;
            dispatch({ type: 'shipping-results/fullfilled', payload: data });
        } catch (e) {
            toast.error(e.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

export const fetchEnviosSearch = (searchParams, page) => async (dispatch) => {
    try {
        dispatch({ type: 'loading/set', payload: true });
        const response = await ENVIOS_API.search(searchParams, page);
        const data = await response.data;
        dispatch({ type: 'shipping-results/fullfilled', payload: data });
    } catch (e) {
        toast.error(e.message);
    } finally {
        dispatch({ type: 'loading/set', payload: false });
    }
};

export const fetchEnviosNoGenerated = (page) => async (dispatch) => {
    try {
        dispatch({ type: 'loading/set', payload: true });
        const response = await ENVIOS_API.getNoGenerated(page);
        const data = await response.data;
        dispatch({ type: 'shipping-results/fullfilled', payload: data });
    } catch (e) {
        toast.error(e.message);
    } finally {
        dispatch({ type: 'loading/set', payload: false });
    }
};

export const fetchEmailsNoSent = () => async (dispatch) => {
    try {
        dispatch({ type: 'loading/set', payload: true });
        const response = await ENVIOS_API.getProviderEmailNotSent();
        const data = await response.data;
        dispatch({ type: 'shipping-results/fullfilled', payload: data });
    } catch (e) {
        toast.error(e.message);
    } finally {
        dispatch({ type: 'loading/set', payload: false });
    }
};

export const updateShippingResults = (newData) => (dispatch) => {
    dispatch({ type: 'shipping-results/update', payload: newData });
};

export const resetShippingResults = () => (dispatch) => {
    dispatch({ type: 'shipping-results/reset' });
};

export const handleUpdateShipmentState =
    (shipmentId, estadoId, isNacional, newState) => (dispatch) => {
        if (!estadoId) return;
        dispatch({
            type: 'shipping-results/change-state',
            payload: { shipmentId, estadoId, isNacional, newState },
        });
    };

export const updateDashboardShipmentState =
    (estadoId, isNacional, newState) => (dispatch) => {
        if (!estadoId) return;
        dispatch({
            type: 'shipping-results/change-state',
            payload: { estadoId, isNacional, newState },
        });
    };

